export default __webpack_public_path__ + "static/1045-9d9e6a494e1a57db433621c2e9c07ae3.gif";